import { LuArrowDown, LuArrowUp, LuChevronsUpDown } from "react-icons/lu";

/**
 * Sort glyph for a column header: unsorted, ascending, or descending.
 *
 * @param {object} props
 * @param {string} props.field
 * @param {string | null} props.sortedField
 * @param {boolean} props.isSortDescending
 * @returns {import('react').JSX.Element}
 */
const SortIcons = ({ field, sortedField, isSortDescending }) => {
    if (field !== sortedField) {
        return <LuChevronsUpDown aria-hidden size={14} />;
    }

    if (isSortDescending) {
        return <LuArrowDown aria-hidden size={14} />;
    }

    return <LuArrowUp aria-hidden size={14} />;
};

export default SortIcons;
